<motif-modal-title>
  <h3>{{ data.title }}</h3>
  <button motifIconButton aria-label="Close modal" [size]="BUTTON_SIZE" (click)="onClose()">
    <motif-icon [iconFunction]="closeIcon" size="32" />
  </button>
</motif-modal-title>

<motif-modal-content>
  <div [innerHTML]="data.message"></div>
</motif-modal-content>

<motif-modal-actions>
  @if (data.cancelButton) {
    <button
      motifButton
      [color]="cancelButton()?.color || 'primary'"
      [type]="cancelButton()?.type || 'button'"
      (click)="onCancel()">
      {{ cancelButton()?.text || 'common.cancel' | translate }}
    </button>
  }
  <button
    motifButton
    [color]="confirmButton().color || 'secondary'"
    [type]="confirmButton().type || 'submit'"
    (click)="onConfirm()">
    {{ confirmButton().text || 'common.confirm' | translate }}
  </button>
</motif-modal-actions>
